<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phUserProfileDetail_Delete_Account"></h2>
    <div class="ya-dialog-content">
      <p [innerHTML]="deleteAccountContent"></p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="closeDialog()">
              <span langkey="phGlobal_Return"></span>
            </button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="deleteAccount()">
              <span langkey="phUserProfileDetail_Delete_Account"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>